import React from 'react'
import { IOption } from 'src/types'
import Select, { ActionMeta, GroupTypeBase, Styles } from 'react-select'

export const dropdownStyles = {
  control: (styles: React.CSSProperties, { menuIsOpen }: { menuIsOpen: boolean }) => ({
    ...styles,
    backgroundColor: '#000',
    paddingTop: '10px',
    borderBottomLeftRadius: menuIsOpen ? '0 !important' : '4px',
    borderBottomRightRadius: menuIsOpen ? '0 !important' : '4px',
  }),
  indicatorContainer: (styles: React.CSSProperties) => ({
    ...styles,
    fill: ' #444041',
  }),
  valueContainer: (styles: React.CSSProperties) => ({
    ...styles,
    paddingLeft: '16px',
  }),
  option: (
    styles: React.CSSProperties,
    { isDisabled, isSelected, isFocused }: { isDisabled: boolean; isSelected: boolean; isFocused: boolean }
  ) => {
    return {
      ...styles,
      backgroundColor: 'var(--poppy-linen-50)',
      fontFamily: 'Brandon Grotesque',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '390',
      lineHeight: '24px',
      color: '#231F20',
      cursor: isDisabled ? 'not-allowed' : 'default',
      position: 'relative',
      height: '55px',
      paddingLeft: '20px',
      margin: '0 7px 0 4px',
      width: 'calc(100% - 11px)',
      display: 'flex',
      alignItems: 'center',
      borderTop: '1px solid var(--poppy-linen-300)',
      ':before': {
        display: !isDisabled && (isSelected || isFocused) ? 'block' : 'none',
        content: '""',
        width: '4px',
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '-4px',
        backgroundColor: '#FF9977',
      },
      ':first-child': {
        border: 'none',
      },
    }
  },
  menu: (styles: React.CSSProperties) => {
    return {
      ...styles,
      top: '103%',
      backgroundColor: 'var(--poppy-linen-50)',
      margin: '0',
      boxShadow: 'none',
      border: '1px solid var(--poppy-linen-300)',
      borderRadius: '4px',
      borderTopLeftRadius: '0',
      borderTopRightRadius: '0',
      paddingRight: '2px',
    }
  },
  menuList: (styles: React.CSSProperties) => {
    return {
      ...styles,
      padding: '0',
      borderRadius: '4px',
      borderTopLeftRadius: '0',
      borderTopRightRadius: '0',
      // -webkit-overflow-scrolling: touch;
      scrollbarWidth: 'thin',
      scrollbarColor: '#c4c4c4 white',
      ':-webkit-scrollbar': {
        height: '5px',
        width: '5px',
        borderRadius: '25px',
      },
    }
  },
}

export interface IDropdownProps {
  id?: string
  inputId?: string
  options?: IOption[]
  value?: IOption
  handleChange?: (value: IOption | null, actionMeta: ActionMeta<IOption>) => void
  handleBlur?: React.FocusEventHandler
  className?: string
  placeholder?: string
}

export const Dropdown = (props: IDropdownProps) => {
  const { id, inputId, options, value, handleChange, handleBlur, className, placeholder } = props

  return (
    <Select
      id={id}
      inputId={inputId}
      isSearchable={true}
      components={{ IndicatorSeparator: () => null }}
      value={value ?? null}
      classNamePrefix="react-select"
      className={`select ${className ?? ''}`}
      onChange={handleChange}
      onBlur={handleBlur}
      maxMenuHeight={230}
      menuPlacement="bottom"
      placeholder={placeholder}
      options={options}
      styles={dropdownStyles as Styles<IOption, false, GroupTypeBase<IOption>>}
    />
  )
}
